export const resources = {
  resourcesFolderInfoText: 'File(s)',
  resourcesItemInfoLastUpdText: 'Updated',
  resourcesItemInfoUploadedText: 'Uploaded',
  resourcesSearchInputText: 'Search',
  resourcesUserActionSheetOptionTitle: 'Copy link',
  resourcesActionCopiedAlertText: 'Link copied!',
  resourcesOwnersCurtainEditOptionText: 'Edit Title',
  resourcesOwnersCurtainDeleteOptionText: 'Delete',
  resourcesOwnerCurtainHideOptionText: 'Hide (Inactive)',
  resourcesEditPopupTitle: 'Edit Title',
  resourcesEditPopupResetButtonTitle: 'Reset',
  resourcesEditPopupApplyButtonTitle: 'Apply',
  resourcesItemEditedAlertText: 'Item has been successfully updated!',
  resourcesHidePopupTitle: 'Hide',
  resourcesHidePopupText: 'Hide this Item?',
  resourcesHidePopupCancelButtonTitle: 'Cancel',
  resourcesHidePopupConfirmButtonTitle: 'Confirm',
  resourcesDeletePopupTitle: 'Delete',
  resourcesDeletePopupText: 'Delete this Item?',
  resourcesDeletePopupCancelButtonTitle: 'Cancel',
  resourcesDeletePopupConfirmButtonTitle: 'Confirm',
  resourcesItemDeletedAlertText: 'Item has been successfully deleted!',
  resourceDetailsLinkText: 'This is an external URL and it will be opened in a new window. Open?',
  resourceDetailsLinkOpenButtonTitle: 'Open',
  resourceDetailsLinkOpenAgainButtonTitle: 'Open Again',
  resourceDetailsLinkCopyURLButtonTitle: 'Copy target URL',
  resourceDetailsLinkCopiedURLAlertText: 'URL copied!',
  resurceDetailsLinkCurtainOptionCopyText: 'Copy link',
  resourceDetailsFileInfoLastUpdText: 'Updated',
  resourceDetailsFileInfoUploadText: 'Uploaded',
  resourceDetailsFileSaveButtonTitle: 'Open',
  resourceDetailsFileCopyButtonTitle: 'Copy link',
  resourcesOwnersCurtainCopyOptionText: 'Copy link',
  resourceDetailsFileLoadingText: 'Downloading...',
  resourceDetailsImageCurtainCopyOptionText: 'Copy link',
  resourceDetailsImageCurtainDownloadOptionText: 'Download',
  resourceFolder: 'Folder',
  resourceAdded: 'Added'
}
